var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPrivacySandboxColored = function SvgPrivacySandboxColored(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 128,
    fill: "none",
    viewBox: "0 0 128 128"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#9E9E9E",
    strokeMiterlimit: 10,
    strokeWidth: 5.6,
    d: "M103.888 23.445c7.325 7.314 9.919 18.372 7.737 30.705-2.181 12.323-9.113 25.644-20.403 36.918-11.291 11.273-24.633 18.194-36.975 20.371-12.353 2.179-23.428-.411-30.753-7.725-7.326-7.313-9.92-18.371-7.737-30.705 2.18-12.322 9.112-25.644 20.403-36.917S60.793 17.898 73.135 15.72c12.352-2.18 23.428.41 30.753 7.724Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#858585",
    strokeMiterlimit: 10,
    strokeWidth: 5.6,
    d: "M120.543 63.585c0 31.342-25.448 56.757-56.85 56.757-31.401 0-56.85-25.415-56.85-56.757S32.292 6.827 63.693 6.827c31.402 0 56.85 25.416 56.85 56.758Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9CD1FB",
    d: "M41.294 20.918H23.622c-4.433 0-8.013-3.589-8.013-8 0-4.426 3.595-8 8.013-8h17.672c4.433 0 8.013 3.589 8.013 8 0 4.396-3.58 8-8.013 8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#05BB72",
    d: "M27.808 83.932v9.332c0 8.958-5.92 17.245-13.91 19.698C5.92 110.496 0 102.248 0 93.264v-9.332l13.91-6.17zM109.625 34.422c6.793 0 12.3-5.499 12.3-12.281s-5.507-12.282-12.3-12.282-12.3 5.499-12.3 12.282c0 6.782 5.506 12.28 12.3 12.28"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4582F4",
    d: "M93.217 32.445H32.48V95.12h60.736z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M71.147 60.162c4.674-4.666 4.674-12.233 0-16.9s-12.252-4.666-16.926 0-4.674 12.234 0 16.9c4.674 4.667 12.252 4.667 16.926 0M40.14 84.15c0-4.805 2.869-9.165 7.293-11.049a41.73 41.73 0 0 1 33.266 0 12 12 0 0 1 7.294 11.049v3.413H40.14z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#241F20",
    strokeMiterlimit: 10,
    strokeWidth: 2.287,
    d: "M50.234 95.119h42.983V50.023"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9CD1FB",
    d: "M113.464 104H84.576L80 112.4l4.576 8.4h28.888l4.576-8.4z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h128v128H0z"
  })))));
};
export default SvgPrivacySandboxColored;